import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSetUser } from '../../context/userContext';
import loginUser from '../../api/loginUser';

import './LogForm.css';

const LogForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const setUser = useSetUser();

  function handleSubmit(e) {
    e.preventDefault();
    const setters = {
      setIsWorking: setLoading,
      setUser,
      setError
    };
    loginUser(email, password, setters);
  }

  return (
    <div className="log-reg-form">
      <div className="container">
        <div className="row">
          <div className="col col-12 col-md-6 offset-md-3">
            <h2 className="form-heading">Hello,</h2>
            <p className="form-subheading">Welcome back!</p>
            <div className="form-wrapper">
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="mb-3">
                  <div className="input-group mb-3">
                    <span className="input-group-text">
                      <i className="bi bi-envelope-fill"></i>
                    </span>
                    <input
                      type="text"
                      className={`form-control form-control-lg ${error?.email && 'is-invalid'}`}
                      id="email"
                      placeholder="Email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <div className="invalid-feedback">{error?.email}</div>
                  </div>
                </div>
                <div className="mb-3">
                  <div className="input-group mb-3">
                    <span className="input-group-text">
                      <i className="bi bi-lock-fill"></i>
                    </span>
                    <input
                      type="password"
                      className={`form-control form-control-lg ${error?.password && 'is-invalid'}`}
                      id="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <div className="invalid-feedback">{error?.password}</div>
                  </div>
                </div>
                <div className={`form-control ${error?.error && 'is-invalid'} d-none`}></div>
                <div className="invalid-feedback mb-3">{error?.error}</div>
                <div className="form-footer">
                  <button className="btn btn-primary" type="submit" disabled={loading}>
                    {loading ? (
                      <>
                        <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Loading...
                      </>
                    ) : (
                      'Login'
                    )}
                  </button>
                  <span>
                    Not registered? <Link to="/register">Create an account!</Link>
                  </span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogForm;
